import { LitElement, html, css, unsafeCSS } from 'lit';
import { RDPropsetContainer } from '../Container/PropContainer.js';

import styles from './UnitNumber.css?raw';

export class propUnit extends RDPropsetContainer {
  static styles = [
    super.styles,
    css`
        ${unsafeCSS(styles)}
    `
  ];
  static properties = {
    //  value: { type: String },
    //  unit: { type: String },
    selectedIndex: { type: Number, reflect: true },
    disabled: { type: Boolean, reflect: true },
    placeholder: { type: String },
    items: { type: Array },
    step: { type: Number, reflect: true },
    min: { type: Number, reflect: true },
    max: { type: Number, reflect: true },
    disableFor: { type: Array },
    emptyFor: { type: Array },
    onInput: { type: Function },
    onChange: { type: Function },
    callback: { type: Function },
    defaultUnit: { type: String }
  };

  constructor() {
    super();
    this.label = '';
    this.value = '';
    this._unit = '';
    this.defaultUnit = '-';
    this._selectedIndex = 0;
    this.selected = false;
    this.disabled = false;
    this.step = 1;
    this.min = -Infinity;
    this.max = Infinity;
    this.placeholder = 'auto';
    this.disableFor = ['auto'];
    this.emptyFor = ['-'];
    this.onInput = null;
    this.onChange = null;
    this.callback = null;
    this._partialDisabled = false;

    /** @type {Array<{leftIcon:string, value:string, rightIcon:string}>} */
    this.items = [
      // { rightIcon: '', value: '-', label: '-', leftIcon: '', selected: false },
    ];
  }

  get unit() {
    return this._unit || this.defaultUnit || '';
  }

  set unit(val) {
    if (this._unit === val) return;
    const oldVal = this._unit;
    this._unit = val;
    if (this.formattedItems.length > 0) {
      const index = this.formattedItems.findIndex((item) => item?.value === val);
      this._selectedIndex = index;
    } else {
      this._selectedIndex = -1;
      // this._unit = this.defaultUnit || '';
    }

    this._partialDisabled = this.disableFor?.includes(val);
    this.requestUpdate('unit', oldVal);
  }

  get selectedIndex() {
    return this._selectedIndex;
  }

  set selectedIndex(val) {
    if (this._selectedIndex === val) return;
    const oldVal = this._selectedIndex;
    this._selectedIndex = val;

    if (this.formattedItems.length > 0) {
      const newUnit = this.formattedItems[val]?.value;
      if (newUnit && newUnit !== this._unit) {
        this._unit = newUnit;
      }
    } else {
      this._unit = this.defaultUnit || '';
    }

    this.requestUpdate('selectedIndex', oldVal);
  }

  firstUpdated() {
    super.firstUpdated();
    this.formattedItems = this.items;
    if (this.unit && this.formattedItems.length > 0) {
      const index = this.formattedItems.findIndex((item) => item?.value === this.unit);
      if (index !== -1) {
        this.selectedIndex = index;
      }
    }
  }

  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);

    if (changedProperties.has('items')) {
      this.formattedItems = this.items;
      // Sync selectedIndex with current unit
      const index = this.formattedItems.findIndex((item) => item?.value === this.unit);
      if (index !== -1) {
        this.selectedIndex = index;
      }
    }

  }

  shouldUpdate(changedProperties) {
    super.shouldUpdate(changedProperties);
    if (changedProperties.has('emptyFor')) {
      if (!Array.isArray(this.emptyFor)) {
        this.emptyFor = [];
        return false;
      }
    }
    return true;
  }

  get value() {
    return this._value || '';
  }

  set value(val) {

    if (typeof val === 'string') {
      let parsed = Utilities.parseCSSUnit(val, this.unit);
      if (parsed) {
        let { value, unit } = parsed;

        if (this.disableFor && this.disableFor.includes(value)) {
          unit = value;
        }

        // Update value and unit (setter will handle selectedIndex sync)
        this._value = value;
        this._unit = unit;
      }
    }
    this.requestUpdate();
  }

  _parseNumberWithUnit(input, allowedUnits) {
    const NUMBER_UNIT_RE = /^\s*([+-]?(?:\d+(?:\.\d+)?|\.\d+))\s*([a-zA-Z%]+)\s*$/;
    if (typeof input !== 'string') return null;
    const m = input.match(NUMBER_UNIT_RE);
    if (!m) return null;

    const value = Number(m[1]);
    if (Number.isNaN(value)) return null;

    const unit = m[2].toLowerCase();
    if (allowedUnits && !allowedUnits.includes(unit)) return null;

    return { value, unit };
  }

  get formattedItems() {
    if (!this._items) return [];
    if (this._items.length === 0) return [];
    if (!Array.isArray(this._items)) return [];
    let formatted = [];
    for (let i = 0; i < this._items.length; i++) {
      if (typeof this._items[i] !== 'object') {
        formatted.push({ value: this._items[i], label: this._items[i], leftIcon: '', rightIcon: '' });
      } else {
        formatted.push({
          value: this._items[i].value || this._items[i].label || '',
          label: this._items[i].label || this._items[i].value || '',
          leftIcon: this._items[i].leftIcon || '',
          rightIcon: this._items[i].rightIcon || ''
        });
      }
    }
    return formatted;
  }

  set formattedItems(val) {
    this._items = val;
  }

  _optionClicked() {
    if (this.disabled) return;
    let items = this.formattedItems;
    let target = this.renderRoot.querySelector('.option-input');
    items.forEach((item, index) => {
      if (index === this.selectedIndex) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });
    this.panel = {
      // target: this,
      size: 'fit',
      placement: 'bottom',
      offsetY: 5,
      offsetX: -10,
      target: target,
      onSelect: (dropdownItem) => {
        this.renderRoot?.querySelector('.option-container')?.focus();
        this.unit = dropdownItem.value;
        items.forEach((item, index) => {
          if (item.value === dropdownItem.value) {
            this.selectedIndex = index;
          }
        });
        if (this.disableFor && this.disableFor.includes(this.unit)) {
          //this.renderRoot?.querySelector('input')?.setAttribute('disabled', 'true');
          this._partialDisabled = true;
        } else {
          //this.renderRoot?.querySelector('input')?.removeAttribute('disabled');
          this._partialDisabled = false;
        }
        let unit = this.unit;
        if (this.emptyFor.includes(unit)) {
          unit = '';
        }
        if (this.onChange && typeof this.onChange === 'function') {
          this.onChange.bind(this)({ value: this.value, unit: unit });
        }
        if (this.callback && typeof this.callback === 'function') {
          this.callback.bind(this)({ value: this.value, unit: unit });
        }
        this.dispatchEvent(new CustomEvent('prop-value-changed', { detail: { value: this.value, unit: unit } }));
      },
      onOpen: () => {
        // console.log('Dropdown opened');
      },
      onClose: () => {
        //console.log('Dropdown closed');
      },
      onHover: (item) => {
        // console.log('Hovered pseudo-class:', item.value);
      },
      items: items || []
    };
    DropdownPanel.show(this.panel);
    this.requestUpdate();
  }

  _formatedValue() {
    let val = this.value;
    let unit = this.unit;
    if (this.emptyFor.includes(unit)) {
      unit = '';
    }
    return val + unit;
  }

  _onInput(e) {
    let v = e.target.value;
    if (v < this.min) v = this.min;
    if (v > this.max) v = this.max;
    this.value = v;
    let unit = this.unit;
    if (this.emptyFor.includes(unit)) {
      unit = '';
    }
    if (this.onInput && typeof this.onInput === 'function') {
      this.onInput.bind(this)({ value: this.value, unit: unit });
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)({ value: this.value, unit: unit });
    }
    this.dispatchEvent(new CustomEvent('prop-value-input', { detail: { value: this.value, unit: unit } }));
  }

  _onChange(e) {
    let v = e.target.value;
    if (v < this.min) v = this.min;
    if (v > this.max) v = this.max;
    this.value = v;
    let unit = this.unit;
    if (this.emptyFor.includes(unit)) {
      unit = '';
    }
    if (this.onChange && typeof this.onChange === 'function') {
      this.onChange.bind(this)({ value: this.value, unit: unit });
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)({ value: this.value, unit: unit });
    }
    this.dispatchEvent(new CustomEvent('prop-value-changed', { detail: { value: this.value, unit: unit } }));
  }

  _renderNumberInput() {
    return html`
      <div class="number-input">
        <input type="number" max="${this.max}" min="${this.min}" step="${this.step}"
               placeholder="${this.placeholder || ''}" .value="${this.value}"
               ?disabled="${this.disabled || this._partialDisabled}" @input="${this._onInput}"
               @change="${this._onChange}" />
      </div>
    `;
  }

  _renderOptionInput() {
    return html`
      <div class="option-input" @click="${this._optionClicked}"><span>${this.unit}</span></div>`;
  }

  renderBody() {
    return html`
      <div class="option-container" tabindex="-1">${this._renderNumberInput()} ${this._renderOptionInput()}</div>`;
  }
}

if (!customElements.get('rd-prop-unit')) {
  customElements.define('rd-prop-unit', propUnit);
}
